import styled from "styled-components";
import { Container } from "../layout/Container";

const Section = styled.section`
  background: hsl(${({ theme }) => theme.colors.navDark});
  padding: 2.5rem 0;
`;

const Inner = styled(Container)`
  text-align: center;
`;

const H1 = styled.h1`
  margin: 0 0 0.5rem;
  font-size: ${({ theme }) => theme.font.heroTitle};
  font-weight: 800;
  color: hsl(${({ theme }) => theme.colors.navDarkForeground});
`;

const P = styled.p`
  margin: 0 auto;
  max-width: min(100%, 48rem);
  font-size: clamp(0.9375rem, 0.88rem + 0.25vw, 1.125rem);
  color: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.6);
`;

export default function CategoriesHero() {
  return (
    <Section>
      <Inner>
        <H1>Browse by Category</H1>
        <P>Find the best deals organized by category</P>
      </Inner>
    </Section>
  );
}
